<template>
  <div v-if="trainingsData.length">
    <v-row no-gutters>
      <v-col cols="12" class="text-start">
        <span class="textLight--text font-weight-medium text-h5">
          {{ $t("course.recentlyOrApprovalCourses") }}
        </span>
      </v-col>
      <v-col cols="12">
        <v-row class="mt-5">
          <div class="d-flex" style="width: 100%; overflow-x: auto">
            <v-col
              v-for="(course, index) in trainingsData"
              :key="index"
              cols="12"
              sm="5"
              md="4"
              lg="3"
            >
              <approval-pending-course-card :course="course" />
            </v-col>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ApprovalPendingCourseCard from "./ApprovalPendingCourseCard.vue";

export default {
  data() {
    return {
      trainingsData: [],
    };
  },
  components: {
    ApprovalPendingCourseCard,
  },
  apollo: {
    getTrainings() {
      return {
        query: require("../../course-module/api/query/getTrainings.gql"),
        variables: {
          limit: 0,
          skip: 0,
          // filterInput: {
          //   approvalStatus: "PENDING",
          // },
        },
        result({ data, loading }) {
          if (data && data.getTrainings && data.getTrainings.trainings) {
            this.trainingsData = data.getTrainings.trainings
              .map(obj => {
                let totalContents = 0;

                if (obj.approvalStatus === "PENDING") {
                  if (obj && obj.trainingModules) {
                    obj.trainingModules.map(module => {
                      totalContents += module.trainingModuleContents.length;
                    });
                  }

                  obj.totalContents = totalContents ? totalContents : 0;

                  return obj;
                }
              })
              .filter(ele => ele !== undefined);
          }
        },
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.hideScroll::-webkit-scrollbar {
  display: none;
}

.hideScroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
